module.exports = __webpack_public_path__ + "media/images/list-bullet-0e6bb7027fea5052edd1454c45629fbe.png";